const stopPropagation = (e: any): void => {
    e.stopPropagation()
    e.preventDefault()
}

export default stopPropagation
